import { useMutation } from "@tanstack/react-query";
import { useNotification, useTranslate } from "@refinedev/core";

import { ApiError } from "@shared/types";
import { Store } from "@modules/stores/types";
import { StoreFormValues } from "@modules/stores/validations";

import { editStoreService } from "./service";
import { UseEditStoreMutationOptions } from "./types";

export function useEditStoreMutation(
  id: string,
  options?: UseEditStoreMutationOptions
) {
  const { open } = useNotification();
  const translate = useTranslate();

  return useMutation<Store, ApiError, Partial<StoreFormValues>>({
    mutationFn: (data) => editStoreService(id, data),
    onSuccess: () => {
      open?.({
        type: "success",
        message: translate("v1/store_admin.success.edit"),
      });
    },
    onError: (error: ApiError) => {
      open?.({
        type: "error",
        message: error.response.data.error,
      });
    },
    ...options,
  });
}
